document.addEventListener('DOMContentLoaded', () => {
  function initProductCompare() {
    const compareSection = document.querySelector('.product-compare');

    if (!compareSection) {
      return;
    }

    function getElements() {
      const iconWrapper = compareSection.querySelector('[data-product-compare-search-icon]');
      return {
        compareToggle: compareSection.querySelector('[data-product-compare-toggle]'),
        compareMenu: compareSection.querySelector('[data-product-compare-menu]'),
        searchInput: compareSection.querySelector('[data-product-compare-search-input]'),
        resultsContainer: compareSection.querySelector('[data-product-compare-results]'),
        collectionResults: compareSection.querySelector('[data-collection-results]'),
        storeResults: compareSection.querySelector('[data-store-results]'),
        emptyState: compareSection.querySelector('[data-empty-state]'),
        searchLoadingSpinner: iconWrapper ? iconWrapper.querySelector('.search-loading-spinner') : null,
        searchIconWrapper: iconWrapper,
      };
    }

    let elements = getElements();
    if (!elements.compareToggle || !elements.compareMenu || !elements.searchInput) {
      return;
    }

    let isDropdownOpen = false;
    let isFetching = false;
    let searchDebounceTimer = null;
    let currentSearchQuery = '';
    let selectedProductHandle = '';
    const sectionId = compareSection.getAttribute('data-section-id');

    function openDropdown() {
      elements = getElements();
      if (!elements.compareMenu) return;

      requestAnimationFrame(() => {
        elements.compareMenu.classList.remove('opacity-0', 'invisible', 'pointer-events-none');
        elements.compareMenu.classList.add('opacity-100', 'visible');
        elements.compareToggle.setAttribute('aria-expanded', 'true');
        isDropdownOpen = true;
        if (elements.searchInput) {
          setTimeout(() => elements.searchInput.focus(), 100);
        }
      });
    }

    function closeDropdown() {
      elements = getElements();
      if (!elements.compareMenu) return;

      requestAnimationFrame(() => {
        elements.compareMenu.classList.remove('opacity-100', 'visible');
        elements.compareMenu.classList.add('opacity-0', 'invisible', 'pointer-events-none');
        elements.compareToggle.setAttribute('aria-expanded', 'false');
        isDropdownOpen = false;
      });
    }

    function toggleDropdown() {
      if (isDropdownOpen) {
        closeDropdown();
      } else {
        openDropdown();
      }
    }

    function attachToggleListeners() {
      elements = getElements();
      if (!elements.compareToggle || !elements.compareMenu) return;

      elements.compareToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleDropdown();
      });

      document.addEventListener('click', (e) => {
        elements = getElements();
        if (elements.compareToggle && elements.compareMenu) {
          const isClickInside =
            elements.compareToggle.contains(e.target) || elements.compareMenu.contains(e.target);
          if (!isClickInside && isDropdownOpen) {
            closeDropdown();
          }
        }
      });

      document.addEventListener('keydown', (e) => {
        if (!(e.key === 'Escape' && isDropdownOpen)) {
          return;
        }
        closeDropdown();
        elements = getElements();
        if (elements.compareToggle) {
          elements.compareToggle.focus();
        }
      });
    }

    function showSearchLoading() {
      elements = getElements();
      if (elements.searchLoadingSpinner) {
        elements.searchLoadingSpinner.classList.remove('hidden');
      }
      if (elements.searchIconWrapper) {
        const svgs = elements.searchIconWrapper.querySelectorAll('svg');
        svgs.forEach(svg => svg.classList.add('hidden'));
      }
    }

    function hideSearchLoading() {
      elements = getElements();
      if (elements.searchLoadingSpinner) {
        elements.searchLoadingSpinner.classList.add('hidden');
      }
      if (elements.searchIconWrapper) {
        const svgs = elements.searchIconWrapper.querySelectorAll('svg');
        svgs.forEach(svg => svg.classList.remove('hidden'));
      }
    }

    function showContentLoading() {
      const content = document.querySelector('#comparison-product-content');
      const accordions = document.querySelector('#comparison-accordions');

      if (content) {
        content.classList.add('opacity-50', 'pointer-events-none');
      }
      if (accordions) {
        accordions.classList.add('opacity-50', 'pointer-events-none');
      }
    }

    function hideContentLoading() {
      const content = document.querySelector('#comparison-product-content');
      const accordions = document.querySelector('#comparison-accordions');

      if (content) {
        content.classList.remove('opacity-50', 'pointer-events-none');
      }
      if (accordions) {
        accordions.classList.remove('opacity-50', 'pointer-events-none');
      }
    }

    function showCollectionResults(visibleItems) {
      elements = getElements();
      if (!elements.collectionResults || !elements.storeResults || !elements.emptyState) return;

      elements.collectionResults.querySelectorAll('li').forEach((item) => {
        item.classList.add('hidden');
      });

      visibleItems.forEach((item) => {
        item.classList.remove('hidden');
      });

      elements.collectionResults.classList.remove('hidden');
      elements.storeResults.classList.add('hidden');
      elements.emptyState.classList.add('hidden');
    }

    function showAllCollectionProducts() {
      elements = getElements();
      if (!elements.collectionResults || !elements.storeResults || !elements.emptyState) return;

      elements.collectionResults.querySelectorAll('li').forEach((item) => {
        item.classList.remove('hidden');
      });

      elements.collectionResults.classList.remove('hidden');
      elements.storeResults.classList.add('hidden');
      elements.emptyState.classList.add('hidden');
    }

    function hideCollectionResults() {
      elements = getElements();
      if (elements.collectionResults) {
        elements.collectionResults.classList.add('hidden');
      }
    }

    function hideStoreResults() {
      elements = getElements();
      if (elements.storeResults) {
        elements.storeResults.classList.add('hidden');
      }
    }

    function showEmptyState() {
      elements = getElements();
      if (!elements.collectionResults || !elements.storeResults || !elements.emptyState) return;

      elements.emptyState.classList.remove('hidden');
      elements.collectionResults.classList.add('hidden');
      elements.storeResults.classList.add('hidden');
    }

    function hideEmptyState() {
      elements = getElements();
      if (elements.emptyState) {
        elements.emptyState.classList.add('hidden');
      }
    }

    function filterCollectionProducts(query) {
      elements = getElements();
      if (!elements.collectionResults) return [];

      const normalizedQuery = query.toLowerCase().trim();

      if (normalizedQuery === '') {
        return null;
      }

      const collectionItems = Array.from(
        elements.collectionResults.querySelectorAll('li')
      );
      const matchedItems = collectionItems.filter((item) => {
        const title = item.textContent.toLowerCase();
        const handle = item.dataset.productHandle;
        return title.includes(normalizedQuery) || handle.includes(normalizedQuery);
      });

      return matchedItems;
    }

    async function fetchStoreWideProducts(query) {
      if (isFetching) return;

      isFetching = true;

      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`
        );
        const data = await response.json();
        const products = data.resources.results.products || [];

        if (products.length > 0) {
          renderStoreResults(products);
          hideCollectionResults();
          hideEmptyState();
        } else {
          showEmptyState();
        }
      } catch (error) {
        console.error('Search failed:', error);
        showEmptyState();
      } finally {
        isFetching = false;
      }
    }

    function renderStoreResults(products) {
      elements = getElements();
      if (!elements.storeResults) return;

      elements.storeResults.innerHTML = '';

      products.forEach((product, index) => {
        const li = document.createElement('li');
        li.className = 'product-compare-menu-item border-b border-gray-100 last:border-b-0';
        li.dataset.productHandle = product.handle;

        const button = document.createElement('button');
        button.type = 'button';
        button.className =
          'w-full text-left px-5 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors';
        button.dataset.productCompareItem = '';
        button.textContent = product.title;

        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          selectComparisonProduct(product.handle);
        });

        li.appendChild(button);
        elements.storeResults.appendChild(li);
      });

      elements.storeResults.classList.remove('hidden');
    }

    async function handleSearch(query) {
      const filtered = filterCollectionProducts(query);

      if (filtered === null) {
        showAllCollectionProducts();
        hideStoreResults();
        hideEmptyState();
      } else if (filtered.length > 0) {
        showCollectionResults(filtered);
        hideStoreResults();
        hideEmptyState();
      } else if (query.trim() !== '') {
        await fetchStoreWideProducts(query);
      } else {
        showEmptyState();
      }

      hideSearchLoading();
    }

    function attachSearchListeners() {
      elements = getElements();
      if (!elements.searchInput) return;

      elements.searchInput.addEventListener('input', function () {
        const query = this.value.trim();
        currentSearchQuery = query;

        showSearchLoading();

        clearTimeout(searchDebounceTimer);

        searchDebounceTimer = setTimeout(() => {
          handleSearch(query);
        }, 500);
      });

      elements.searchInput.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') {
          return;
        }
        e.preventDefault();
        clearTimeout(searchDebounceTimer);
        showSearchLoading();
        handleSearch(this.value.trim());
      });
    }

    function attachCollectionItemListeners() {
      elements = getElements();
      if (!elements.collectionResults) return;

      const items = elements.collectionResults.querySelectorAll('[data-product-compare-item]');
      items.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const handle = item.closest('[data-product-handle]')?.dataset.productHandle;
          if (handle) {
            selectComparisonProduct(handle);
          }
        });
      });
    }

    async function selectComparisonProduct(handle) {
      if (!handle || isFetching) return;

      closeDropdown();

      isFetching = true;
      showContentLoading();

      try {
        const url = new URL(window.location.origin + window.location.pathname);
        url.searchParams.set('sections', sectionId);
        url.searchParams.set('compare_product', handle);

        const response = await fetch(url.toString());
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const sectionHTML = data[sectionId];

        if (!sectionHTML) {
          console.error('Available keys in response:', Object.keys(data));
          throw new Error(`Section HTML not found under key "${sectionId}"`);
        }

        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHTML, 'text/html');

        const newContent = doc.querySelector('#comparison-product-content');
        const currentContent = document.querySelector('#comparison-product-content');

        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;

          setTimeout(() => {
            elements = getElements();
            attachToggleListeners();
            attachSearchListeners();
            attachCollectionItemListeners();
          }, 50);
        }

        const newAccordions = doc.querySelector('#comparison-accordions');
        const currentAccordions = document.querySelector('#comparison-accordions');

        if (newAccordions && currentAccordions) {
          currentAccordions.innerHTML = newAccordions.innerHTML;
        }

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('compare_product', handle);
        window.history.pushState({}, '', newUrl.toString());

        selectedProductHandle = handle;

        setTimeout(() => {
          const updatedSearchInput = document.querySelector('[data-product-compare-search-input]');
          if (!updatedSearchInput) {
            return;
          }
          updatedSearchInput.value = '';
          currentSearchQuery = '';
          const updatedCollectionResults = document.querySelector('[data-collection-results]');
          if (updatedCollectionResults) {
            updatedCollectionResults.querySelectorAll('li').forEach(item => item.classList.remove('hidden'));
          }
          document.querySelector('[data-store-results]')?.classList.add('hidden');
          document.querySelector('[data-empty-state]')?.classList.add('hidden');
        }, 100);
      } catch (error) {
        console.error('Failed to load comparison product:', error);
      } finally {
        isFetching = false;
        hideContentLoading();
      }
    }

    function initializeListeners() {
      attachToggleListeners();
      attachSearchListeners();
      attachCollectionItemListeners();
      showAllCollectionProducts();
    }

    initializeListeners();
  }

  initProductCompare();
});
